module.exports = __webpack_public_path__ + "static/img/11497-detailp.4a52c18.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/11497-detailp.jpeg
// module id = 205
// module chunks = 1